import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { config } from "./config";
import { migrateLegacyKeys } from "./device/legacyKeys";
import "./styles.css";

async function boot() {
  // Mock-first: install the dev mock of the device API before anything calls it.
  if (config.useMock) {
    const { installMockServer } = await import("./mock/mockServer");
    installMockServer();
  }

  await migrateLegacyKeys();

  const root = document.getElementById("root");
  if (!root) throw new Error("missing #root");
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void boot();
